import { ModuleSidebar } from "@/components/modules/ModuleSidebar";
import { MODULES } from "@/lib/modules/registry";

export function JuridicasSidebar() {
  return <ModuleSidebar config={MODULES.juridicas} />;
}
